"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("../scss/main.scss");
var HeroCarousel;
(function (HeroCarousel) {
    const $heroes = document.querySelectorAll('.hero-carousel.component');
    const configuration = {
        type: 'carousel',
        gap: 0,
        autoplay: 4000,
        animationDuration: 600,
        animationTimingFunc: 'linear',
        keyboard: true
    };
    $heroes.forEach(($hero) => {
        init($hero);
    });
    function init($hero) {
        const $target = $hero.querySelector('.glide');
        const $slides = $target.querySelectorAll('.glide__slide');
        const slidesLength = $slides.length;
        const controller = new Glide($target, Object.assign(Object.assign({}, configuration), { type: slidesLength > 1 ? 'carousel' : 'slider', swipeThreshold: slidesLength > 1 ? 80 : false, dragThreshold: slidesLength > 1 ? 120 : false }));
        if (slidesLength > 1) {
            generateBullets($target, slidesLength);
        }
        controller.mount();
        controller.pause();
        //Save controller to allow later use by third parties
        $hero['glideController'] = controller;
    }
    function generateBullets($target, slidesLength) {
        const $bullets = $target.querySelector('.glide__bullets');
        const $bullet = $target.querySelector('.glide__bullet');
        for (let i = 0; i < slidesLength; i++) {
            const $navControl = $bullet.cloneNode(true);
            $navControl.setAttribute('data-glide-dir', `=${i}`);
            $navControl.classList.remove('hidden');
            $bullets.appendChild($navControl);
        }
    }
})(HeroCarousel || (HeroCarousel = {}));
